export default __webpack_public_path__ + "static/media/banner4.651712b8.svg";